import Sticker from './Sticker';
import WithQuery from 'components/layout/WithQuery';
import useRewardsStore from 'graph/state/query-hooks/use-rewards-store';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { AppRoutes } from 'types';

const Stickers: React.FC = () => {
  const classes = styles();
  const navigate = useNavigate();
  const [{ charactersRewards, error }] = useRewardsStore();

  const handleOnCardClick = (character: string) => {
    navigate(`/${AppRoutes.REWARDS}/${character}`);
  };

  return (
    <Box className={classes.container}>
      <WithQuery error={error}>
        <Box className={classes.grid}>
          {charactersRewards.map(
            (characterReward, index) =>
              characterReward?.studentRewards && (
                <Sticker
                  key={characterReward?.character.id ?? index}
                  {...characterReward}
                  onCardClick={handleOnCardClick}
                />
              )
          )}
        </Box>
      </WithQuery>
    </Box>
  );
};

const styles = makeStyles((theme) => ({
  container: {
    //TODO: Define app breakpoints
    maxWidth: 1024,
    display: 'flex',
    margin: '0 auto',
    height: '100%',
    alignItems: 'center',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gridGap: theme.typography.pxToRem(2),
  },
}));

export default Stickers;
